import Sortable from 'sortablejs';

const pageContent = document.querySelector('.content-wrapper');
const inputs = document.querySelectorAll('.block-library__input');
const navElement = document.querySelector('.block-library__nav');
const navWrappers = document.querySelectorAll('.block-library__nav > li');
const navHeadingButtons = document.querySelectorAll(
	'.block-library__nav-heading-button'
);
const toggleButtons = document.querySelectorAll(
	'.block-library__toggle-button'
);
const hoverLabelsToggleButton = document.querySelector(
	'.block-library__hover-labels-toggle-button'
);
const resetOrderButton = document.querySelector(
	'.block-library__reset-order-button'
);
const blockLibrarySection = document.querySelector('.block-library');
const childElements = document.querySelectorAll('.content-wrapper > *');
let sortable; // eslint-disable-line no-unused-vars
const originalOrder = []; // eslint-disable-line no-unused-vars
const toggleEvent = new Event('block-library-change');

const toggleInputs = (e) => {
	e.preventDefault();

	if (e.currentTarget.hasAttribute('data-category')) {
		const dataCategory = e.currentTarget.getAttribute('data-category');
		let categoryInputs;

		if ('all' === dataCategory) {
			categoryInputs = document.querySelectorAll('.block-library__input');
		} else {
			categoryInputs = document.querySelectorAll(
				'ul[data-category="' + dataCategory + '"] .block-library__input'
			);
		}

		if (categoryInputs.length) {
			let checked = false;

			if (e.currentTarget.classList.contains('block-library__show-all')) {
				checked = true;
			}

			categoryInputs.forEach((input) => {
				input.checked = checked;
			});

			changeInput();
		}
	}
};

const changeInput = (sort = true) => {
	const url = new URL(window.location);
	let visibleIds = []; // eslint-disable-line prefer-const
	let currentOrder = url.searchParams.get('order');

	if (false !== sort) {
		if (currentOrder) {
			currentOrder = currentOrder.split('_');
		} else {
			currentOrder = sortable.toArray();
		}
	}

	if (
		hoverLabelsToggleButton &&
		hoverLabelsToggleButton.classList.contains('active')
	) {
		url.searchParams.append('hide-hover-labels', '1');
	} else {
		url.searchParams.delete('hide-hover-labels');
	}

	inputs.forEach((input) => {
		const name = input.getAttribute('name');
		url.searchParams.delete(name);

		if (input.checked) {
			blockLibrarySection.classList.add('visible-' + name);
			url.searchParams.append(name, 'v');

			visibleIds.push(name);
		} else {
			blockLibrarySection.classList.remove('visible-' + name);
			url.searchParams.append(name, 'h');
		}
	});

	if (false !== sort) {
		const visibleItems = currentOrder.filter((value) => {
			if (visibleIds.indexOf(value.split('-')[0]) >= 0) {
				return value;
			}

			return false;
		});

		currentOrder = currentOrder.filter((value) => {
			if (visibleItems.indexOf(value) === -1) {
				return value;
			}

			return false;
		});

		const newOrder = visibleItems.concat(currentOrder);

		sortable.sort(newOrder, true);

		url.searchParams.delete('order');
		url.searchParams.append('order', newOrder.join('_'));
	}

	window.history.pushState({}, '', url);

	window.dispatchEvent(toggleEvent);
};

const hoverLabelsToggle = (e) => {
	e.preventDefault();

	if (e.currentTarget.classList.contains('active')) {
		e.currentTarget.classList.remove('active');
		blockLibrarySection.classList.remove('hide-hover-labels');
	} else {
		e.currentTarget.classList.add('active');
		blockLibrarySection.classList.add('hide-hover-labels');
	}

	changeInput();
};

const resetOrder = (e) => {
	e.preventDefault();
	const url = new URL(window.location);

	url.searchParams.delete('order');

	window.history.pushState({}, '', url);

	sortable.sort(originalOrder, true);

	changeInput();
};

const toggleMenus = (e) => {
	e.preventDefault();

	if (!e.currentTarget.classList.contains('active')) {
		navHeadingButtons.forEach((button) => {
			button.classList.remove('active');
		});
	}

	e.currentTarget.classList.toggle('active');
};

const initMouseOver = () => {
	if (navWrappers.length) {
		let height;
		let multipleRows = false;

		for (const navWrapper of navWrappers) {
			if (navWrapper.offsetTop > height) {
				multipleRows = true;
				break;
			}

			height = navWrapper.offsetTop;
		}

		if (true === multipleRows) {
			navElement.classList.remove('hover-enabled');
		} else {
			navElement.classList.add('hover-enabled');
		}
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (childElements.length) {
			let blockID = '';
			let blockTitle = '';
			let counter = 0;

			childElements.forEach((childElement) => {
				if (
					childElement.classList.contains(
						'block-library__section-placeholder'
					)
				) {
					blockID = childElement.getAttribute('data-block-id');
					blockTitle = childElement.getAttribute('data-block-title');
					childElement.remove();
					counter = 0;
				} else {
					counter++;
					childElement.setAttribute(
						'data-block-id',
						blockID + '-' + counter
					);
					childElement.setAttribute('data-block-title', blockTitle);

					originalOrder.push(blockID + '-' + counter);
				}
			});
		}

		if (pageContent && navElement) {
			sortable = Sortable.create(pageContent, {
				filter: '.block-library, .block-library__hero',
				dataIdAttr: 'data-block-id',
				onMove(evt) {
					if (
						evt.related.classList.contains('block-library') ||
						evt.related.classList.contains('block-library__hero')
					) {
						return false;
					}
				},
				onEnd() {
					const url = new URL(window.location);

					url.searchParams.delete('order');
					url.searchParams.append(
						'order',
						sortable.toArray().join('_')
					);

					window.history.pushState({}, '', url);

					changeInput(false);
				},
			});
		}

		if (blockLibrarySection) {
			if (inputs.length) {
				inputs.forEach((input) => {
					input.addEventListener('change', changeInput);
				});

				changeInput();
			}

			if (toggleButtons.length) {
				toggleButtons.forEach((toggleButton) => {
					toggleButton.addEventListener('click', toggleInputs);
				});
			}

			if (hoverLabelsToggleButton) {
				hoverLabelsToggleButton.addEventListener(
					'click',
					hoverLabelsToggle
				);
			}

			if (resetOrderButton) {
				resetOrderButton.addEventListener('click', resetOrder);
			}
		}

		if (navHeadingButtons) {
			initMouseOver();

			navHeadingButtons.forEach((button) => {
				button.addEventListener('click', toggleMenus);
			});
		}

		document.body.classList.add('block-library-initialized');
	},
	loaded() {},
	resized() {
		initMouseOver();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
